<template>
	<div>
		<el-card shadow="never">
			<el-form :inline='true'>
				<el-form-item>
					<el-button type="primary" @click="addAdminClick('新增')">下发课程
					</el-button>
				</el-form-item>
				<!-- <el-form-item>
					<el-button type="primary" @click="downLoadTemp">下载模板
					</el-button>
				</el-form-item> -->
			</el-form>
			<el-table :data="tableData" border class="table-wrap"
				:header-cell-style="{background:'#eef1f6',color:'#606266'}" @selection-change="handleChange">
				<el-table-column prop="course_name" label="课程名称" align="center">
				</el-table-column>
				<el-table-column prop="num" label="下发章节数" fit align="center">
				</el-table-column>
				<el-table-column prop="type" label="下发类型" fit align="center">
					<template slot-scope="scope">
						{{scope.row.type==1?'个人用户':scope.row.type==2?'全体用户':'企业用户'}}
					</template>
				</el-table-column>
				<el-table-column prop="user" label="下发用户" fit align="center">
				</el-table-column>
				<el-table-column prop="create_time" label="下发时间" fit align="center">
				</el-table-column>
				<el-table-column prop="status" label="下发状态" fit align="center">
					<template slot-scope="scope">
						{{scope.row.status==1?'已下发':'已撤回'}}
					</template>
				</el-table-column>
				<el-table-column label="操作" width="200px" align="center" fit>
					<template slot-scope="scope">
						<div class="operation-wrap">
							<span class="operation-item" @click="editAdminClick(scope.row)">查看</span>
							<span class="operation-item delete" v-if="scope.row.status==1"
								@click="deleteClick(scope.row)">
								撤回</span>
							<span class="operation-item" style="color: #a5a5a5;" v-if="scope.row.status==2">
								撤回</span>
						</div>
					</template>
				</el-table-column>
			</el-table>

			<common-dialog :titleType="'撤回'" :title="dialogTitle" :dialogVisible="dialogVisible"
				@cancel="dialogCancelClick" @confirm="dialogConfirmClick" @dialog-close="dialogClose">
				<div class="dialog-body-wrap">
				</div>
			</common-dialog>


			<common-pagination :total="total" :page_size="page_size" :page_index="page_index"
				@page-change="handlePageChange" @size-change="handleSizeChange"></common-pagination>

			<CourseLssuedDialog :uuid="selectForm" :dialogProp="editdialogVisible" @input="closeDialog"
				@confirm="confirmDialog">
			</CourseLssuedDialog>
		</el-card>
	</div>
</template>

<script>
	import CommonDialog from "@/components/CommonDialog";
	import operations from "@/mixins/operations";
	import CourseLssuedDialog from "./components/CourseLssuedDialog.vue"
	import CommonPagination from "@/components/CommonPagination";
	import {
		getSendCourseList,
		deleteSendCourse,
		UserDisable
	} from "@/api/course"
	import {
		mapState
	} from "vuex";
	import utils from "@/jslibs/utils"

	export default {
		name: "hotellist",
		mixins: [operations],
		data() {
			return {
				total: 0,
				page_size: 10,
				page_index: 1,
				tableData: [],
				selectedTabIndex: "1",
				dataForm: {
					key: "",
					is_disable: '1',
					level: '',
					registerTime: '',
					userStatus: ''
				},
				showDialog: false,
				showDialogType: "Authentication",
				showDialogTitle: '',
				cancelBtnText: "",
				userAuthInfo: {},
				level: [{
					value: '等级',
					label: '等级'
				}],
				userStatuList: [{
					value: '状态',
					label: '状态'
				}],
				allChioce: [],
				allSelectIdList: [],
				selectForm: {},
				editdialogVisible: false,
				//删除弹框开始
				dialogTitle: "",
				dialogType: "",
				dialogVisible: false,
				form: {},
				//删除弹框结束
				passwordShow: false,
				passwordForm: {}
			};
		},
		components: {
			CommonPagination,
			CourseLssuedDialog,
			CommonDialog
		},
		mounted() {
			this.network().getUserTableList();
		},
		computed: {
			...mapState(["imgDomain"])
		},
		methods: {
			downLoadTemp() {
				window.location.href =
					'https://gymoo-project-cdn.oss-cn-shenzhen.aliyuncs.com/innovation/%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
			},
			resetPasswordClick(row) {
				this.passwordShow = true;
				this.passwordForm = row;
			},
			async UserDisableClick(item, is_disable) {
				const {
					status
				} = await UserDisable({
					id: item.uuid,
					is_disable: is_disable
				});
				this.$message.success('操作成功')
				if (status === 200) {
					this.network().getUserTableList();
				}
			},
			//删除弹框开始
			dialogCancelClick: () => {
				this.dialogVisible = false
			},
			async dialogConfirmClick() {
				if (this.dialogType === "delete") {
					let postData = {
						uuid: this.form.uuid
					}
					const {
						status
					} = await deleteSendCourse(postData);
					this.$message.success('撤回成功')
					if (status === 200) {
						this.dialogVisible = false;
						return;
					}
				}
			},
			dialogClose() {
				this.dialogVisible = false;
				this.network().getUserTableList();
			},
			deleteClick(row) {
				this.form = JSON.parse(JSON.stringify(row));
				this.dialogVisible = true;
				this.dialogType = "delete";
				this.dialogTitle = "当前下发的课程吗";
			},
			//删除弹框结束
			closeDialog(row) {
				this.passwordShow = false
				this.editdialogVisible = false;
			},
			confirmDialog(row) {
				this.editdialogVisible = row;
				this.network().getUserTableList()
			},
			//添加
			addAdminClick() {
				this.selectForm = {};
				this.selectForm.role_uuid = this.uuid
				this.editdialogVisible = true;
			},
			//修改
			editAdminClick(row) {
				this.editdialogVisible = true;
				this.selectForm = row;
				this.selectForm.role_uuid = this.uuid
			},
			handleChange(row) {
				this.allSelectIdList = row.map(item => item.user_id);
			},
			tabChange(e) {
				this.dataForm.status = e
				this.network().getUserTableList();
			},
			/**文件上传选择完成时触发的事件函数**/
			onFileChange(e) {
				let file = e.target.file[0]
			},
			handlePageChange(page) {
				this.event().handlePageChange(page);
			},
			handleSizeChange(size) {
				this.event().handleSizeChange(size);
			},
			/**
			 *触摸，响应事件放在event下，如onclick函数,onchange函数等
			 *特殊情况:像一些需要接收参数的事件，如onchange原生事件或者是vue中的emit有参数的事件,必须得写在event外部，否则无法得到接收参数。像这种事件特殊处理
			 **/
			event() {
				return {
					clearSearch: () => {
						this.dataForm.key = ''
						this.dataForm.parent_id = ''
						this.page_index = 1
						this.network().getUserTableList();
					},
					handleClick: () => {
						this.network().getUserTableList();
					},
					toggleTab: (index) => {
						this.allChioce = [];
						this.dataForm.is_blacklist = index
						this.network().getUserTableList();
					},
					/**
					 * 点击全选
					 * @param {Object} index
					 */
					onAllChioceChange: (row) => {
						//全选将List中的id提取出来
						this.allSelectIdList = row.map(item => item.user_id);
					},
					/**
					 * 已认证用户点击
					 */
					onShowDialogClick: (btn, data) => {
						this.showDialog = true;
						this.showDialogType = btn;
						this.userAuthInfo = data;
						this.showDialogTitle = '认证信息';
						this.cancelBtnText = "返回"
					},
					onCloseModalClick: () => {
						this.showDialog = false;
					},
					/**
					 * 查看用户详情
					 */
					handleOperationClick: (data) => {
						this.$router.push({
							path: "/user-detail?uuid=" + data.uuid
						})
					},
					/**
					 * 解禁/禁用
					 * @param {Object} uuid
					 */
					handleIsDisableclick: (uuid, is_blacklist) => {
						// var uuidList = uuid.split(",");
						this.network().newWorkIsDisableClick(uuid, is_blacklist);
					},
					handlePageChange: (page) => {
						this.page_index = page;
						this.network().getUserTableList();
					},
					handleSizeChange: (size) => {
						this.page_size = size;
						this.network().getUserTableList();
					},
					onBatchApprovalClick: (isDisable) => {
						if (this.allSelectIdList.length > 0) {
							if (isDisable) { // true 解
								this.network().batchUnDisable()
							} else {
								this.network().batchDisable()
							}
						} else {
							this.$message.error('请点击全选选项');
						}
					},
				}
			},
			/**
			 *网络访问相关函数
			 **/
			network() {
				return {
					getUserTableList: async () => {

						let postData = {
							page_size: this.page_size,
							page_index: this.page_index,
						};
						const {
							status,
							data
						} = await getSendCourseList(postData);
						if (status !== 200) return;
						this.tableData = data.result.data;
						this.total = data.result.total;
					},

					batchDisable: async () => {
						let postData = {
							user_ids: this.allSelectIdList
						}
						const {
							status,
							data
						} = await batchDisable(postData);
						if (status !== 200) return;
						this.network().getUserTableList();
					},
					batchUnDisable: async () => {
						let postData = {
							user_ids: this.allSelectIdList
						}
						const {
							status,
							data
						} = await batchUnDisable(postData);
						if (status !== 200) return;
						this.network().getUserTableList();
					},


					disableUser: async (row) => {
						let postData = {
							user_id: row.user_id
						}
						const {
							status,
							data
						} = await disableUser(postData);
						if (status !== 200) return;
						this.network().getUserTableList();
					},

					ableUser: async (row) => {
						let postData = {
							user_id: row.user_id
						}
						const {
							status,
							data
						} = await ableUser(postData);
						if (status !== 200) return;
						this.network().getUserTableList();
					},
				}
			},
			/**
			 * 一般放处理业务逻辑较多的私人函数
			 **/
			handler() {
				return {
					handleListA(list) {
						for (var i = 0; i < list.length; i++) {
							//handle service
						}
					},
					/**
					 **校验表单输入
					 **/
					verifyInput() {},

				}
			}

		}
	};
</script>

<style lang="less" scoped>
	@import "~@/assets/styles/variables.less";
	@import "~@/assets/styles/mixins.less";

	.table-wrap {
		.table-wrap(5px);
	}

	.m-content {
		width: 12rem;
	}

	.m-tab {
		position: relative;
		margin-bottom: 2.1875rem;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.m-tab-item {
		padding-right: 2.0625rem;
		color: #8D8EA6;
		font-size: 1.375rem;
		text-align: center;
	}

	.m-tab-item-active {
		color: #409eff;
	}

	.tab-line {
		height: 2px;
		background: #409eff;
		position: absolute;
		bottom: 0;
		transition: all 0.3s ease;
	}

	.tab-line-0 {
		width: 3rem;
		left: 0;
	}

	.tab-line-1 {
		width: 5rem;
		left: 1;
	}
</style>